import React, { useState } from "react";
import Subheading from "@hui/_atoms/subheading/Subheading";
import Paragraph from "@hui/_atoms/paragraph/Paragraph";
import postFile from "../../../API/onboarding/postFile";
import I18n from "../../../utilities/translations";
import { postProofOfAddress } from "../../../API/onboarding/proof_of_address.api";
import handleError from "../../../API/utils/handleError";
import { FileUpload } from "../../inputs/file_upload/file_upload"
import FormWrapper from "./Shared/FormWrapper";
import FormBody from "./Shared/FormBody";
import FormButton from "./Shared/FormButton";

const ProofOfAddressForm = ({stateUpdate} : {stateUpdate: (...args) => void}) => {

  const ctx = { scope: "onboarding.v3.proof_of_address" };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileDroppedOrSelected, setDroppedOrFileSelected] = useState(false);

  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setDroppedOrFileSelected(true)
    }
  };

  // Triggered when drag and dropped file
  const handleSuccess = () => {
    setSelectedFile(null)
    setDroppedOrFileSelected(true)
  }

  const handleRemoveFile = () => {
    setDroppedOrFileSelected(false)
    setSelectedFile(null)
  }

  const constructAndUploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    await postFile(formData, Routes.document_upload_api_onboarding_proof_of_addresses_path());
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try { 
      if(selectedFile){
        await constructAndUploadFile(selectedFile)
      }
      const res = await postProofOfAddress()
      if (res.status === "ok") {
        stateUpdate(res.data.state)}
      else {
        handleError(res)
      }
    } catch (err) {
      toastr.error("Something went wrong, please try again");
      throw err
    }
  }
  return (<>
    <FormWrapper>
      <form onSubmit={onSubmit} className="tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden">
        <FormBody>
          <div className="tw-row-span-9 md:tw-row-span-full">
            <Subheading>{I18n.t("paragraph_1", ctx)}</Subheading>
            <Paragraph>{I18n.t("paragraph_2", ctx)}</Paragraph>
            <ul className="tw-ml-4 list-disc !tw-list-outside tw-text-base tw-text-gray-700">
              <li>{I18n.t("document_options.item_1", ctx)}</li>
              <li>{I18n.t("document_options.item_2", ctx)}</li>
              <li>{I18n.t("document_options.item_3", ctx)}</li>
              <li>{I18n.t("document_options.item_4", ctx)}</li>
            </ul>
            <FileUpload 
              targetObject={{ model: "identity_verification_attributes[proof_of_address_attributes]", id: 1}}
              url={Routes.document_upload_api_onboarding_proof_of_addresses_path()}
              required={true}
              inputProps={{id: "user[user_verification_attributes][verification_document]"}}
              requestMethod="POST"
              onFileUpload={handleFileInputChange}
              onSuccess={handleSuccess}
              onRemoveFile={handleRemoveFile}
            ></FileUpload>
          </div>
        </FormBody>
        <FormButton>
          <div>
            <input disabled={!fileDroppedOrSelected} type="submit" title="next" value="Next" className="hnry-button hnry-button--primary tw-w-full"/>
          </div>
        </FormButton>
      </form>
    </FormWrapper>
  </>
  )
}
export default ProofOfAddressForm